import React from 'react'
import LoadingPanle from './Loading.gif'
import './simpleloader.scss'


const SimpleLoader = () => {
  return (
    <>
        <div className="loader">
            <img src={LoadingPanle} alt="" />
        </div>
    </>
  )
}

export default SimpleLoader
